import styled from 'styled-components';

export const LabelStatus = styled.div`
  & .badge {
    padding: 0.5rem;
    min-width: 140px;
  }
`;
